require("./src/styles/tailwind.css");
// require("./src/styles/antd.less");
require("./src/styles/tailwind-utils.css");
require("./src/styles/global.css");

export const onClientEntry = () => {
  if (process.env.NODE_ENV !== "production") {
    const React = require("react");

    const whyDidYouRender = require("@welldone-software/why-did-you-render");

    whyDidYouRender(React, {
      trackAllPureComponents: true,
    });
  }
};
